import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  NbAccordionModule,
  NbButtonModule,
  NbCheckboxModule,
  NbIconModule,
  NbInputModule,
  NbOptionModule,
  NbSelectModule,
  NbTooltipModule
} from '@nebular/theme';
import { SurveyAnswersComponent } from '../survey-answers/survey-answers.component';

@Component({
  selector: 'app-survey-questions',
  templateUrl: './survey-questions.component.html',
  styleUrls: ['../../../../../shared/common_syles.css'],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NbAccordionModule,
    NbButtonModule,
    NbIconModule,
    NbInputModule,
    NbSelectModule,
    NbOptionModule,
    NbCheckboxModule,
    NbTooltipModule,
    SurveyAnswersComponent
  ],
  standalone: true
})
export class SurveyQuestionsComponent {
  @Input() group!: FormGroup;
  @Input() qi!: number;

  @Output() addAnswer = new EventEmitter<void>();
  @Output() addAction = new EventEmitter<{ ai: number }>();
  @Output() removeQuestion = new EventEmitter<void>();
  @Output() removeAnswer = new EventEmitter<{ ai: number }>();
  @Output() removeAction = new EventEmitter<{ ai: number; aci: number }>();

  public questionTypes = [
    'radio',
    'thumbs_up_down',
    'rating_nps',
    'button',
    'checkbox',
    'transition',
    'sentiment_scale_5'
  ];

  public answers(): FormArray<FormGroup> {
    return this.group.get('answers') as FormArray<FormGroup>;
  }
}
